import { datatype, random } from 'faker'
import { FormikValues } from 'formik'

import { momentDateHandler } from '../../date/moment-date-handler'
import { currencies, getLongRatings, getShortRatings, LongRatings, ShortRatings } from '../../models'

const { formatIso, newDate } = momentDateHandler

export interface Isin {
  id: number
  isin: string
  type: string
  issuer: string
  coupon: number
  maturity: Date
  currency: string
  frnIssueMargin?: number
  frnBenchmark?: string
  maturityHorizonDays?: number
  interestPaidCode?: string
  previousCouponDate?: string
  nextCouponDate?: string
  issuerRatingLong: LongRatings
  issuerRatingShort: ShortRatings
  isinRatingLong: LongRatings
  isinRatingShort: ShortRatings
}

export const mockIsin = (overrides?: Partial<Isin>): Isin => ({
  id: datatype.number(),
  isin: random.alphaNumeric(12),
  type: random.arrayElement(Object.values(isinInstrumentTypes)),
  issuer: random.alpha({ count: 5 }),
  coupon: datatype.number({ min: 0, max: 100, precision: 4 }),
  maturity: new Date(),
  currency: random.arrayElement(currencies),
  issuerRatingLong: random.arrayElement(Object.values(getLongRatings())),
  issuerRatingShort: random.arrayElement(Object.values(getShortRatings())),
  isinRatingLong: random.arrayElement(Object.values(getLongRatings())),
  isinRatingShort: random.arrayElement(Object.values(getShortRatings())),
  ...overrides,
})

export interface IsinFormValues {
  isin: string
  type: string
  issuer: string
  coupon: number
  maturity: Date
  currency: string
  frnIssueMargin?: number
  frnBenchmark?: string
}

export const isinFormInitialValues: IsinFormValues = {
  isin: '',
  type: '',
  issuer: '',
  coupon: null,
  maturity: null,
  currency: 'AUD',
  frnIssueMargin: 0.0,
  frnBenchmark: '3mBBSW',
}

export interface UpdateIsin {
  isin: string
  eodDate: string
  cleanPrice: number
  grossPrice: number
  couponDate: string
  frnSwapRate: number
  yieldOrTradeMargin: number
}

export interface IsinRatingFormValues extends FormikValues {
  startDate: Date
  short: string
  long: string
}

export const isinRatingFormInitialValues: IsinRatingFormValues = {
  startDate: new Date(),
  short: '',
  long: '',
}

export const isinInstrumentTypes = {
  bond: 'Fixed Interest Bonds',
  frn: 'Floating Rate Notes',
  frtd: 'Floating Rate TDs',
}

export const transformFormValuesToIsinPayload = (formValues: IsinFormValues) => ({
  ...formValues,
  isin: formValues.isin.toLocaleUpperCase(),
  maturity: formatIso({ date: newDate(formValues.maturity) }),
  frnBenchmark: formValues.type === isinInstrumentTypes.bond ? undefined : formValues.frnBenchmark,
  frnIssueMargin: formValues.type === isinInstrumentTypes.bond ? undefined : formValues.frnIssueMargin,
  coupon: formValues.type === isinInstrumentTypes.bond ? formValues.coupon : undefined,
})
